
require('dotenv').config();

export const webDomainClient = process.env.REACT_APP_GUNDER_CLIENT || process.env.WEB_DOMAIN_CLIENT;
